/* istanbul ignore file */
import { AssemblerContext, VariantValues } from '@/types/environment';

import { Config } from './types';

// please don't use nested conditionals here !!!
// this code could be simplified with more elaborate conditionals or switch
// statement, but unfortunately webpack has problems with understanding that
// and conditional import works best with simple conditions
//
// this is good:
// if (process.env.SOME_VARIABLE === 'test') { ... }
//
// this is not good:
// if (process.env.SOME_VARIABLE === 'test') { ... }
// else if (process.env.SOME_OTHER_VARIABLE === 'test2') { ... }
// else { ... }

// please don't use dynamic directory names from custom variables but directly from environment
// That way not all files from directory will be added to bundle

function getAppConfig() {
  if (
    !process.env.REACT_APP_VARIANT ||
    !Object.values(VariantValues).includes(process.env.REACT_APP_VARIANT)
  ) {
    return {};
  }
  if (process.env.NODE_ENV === 'test') {
    return require(`./${process.env.REACT_APP_VARIANT}/test.json`);
  }
  if (process.env.REACT_APP_ENVIRONMENT === 'nonprod') {
    return require(`./${process.env.REACT_APP_VARIANT}/nonprod.json`);
  }
  if (process.env.REACT_APP_ENVIRONMENT === 'prod') {
    return require(`./${process.env.REACT_APP_VARIANT}/prod.json`);
  }
  return require(`./${process.env.REACT_APP_VARIANT}/nonprod.json`);
}

function getConfig(): Config {
  let appConfig = getAppConfig();

  if (process.env.NODE_ENV === 'test') {
    return appConfig;
  }

  return {
    ...appConfig,
    features: {
      ...appConfig.features,
    },
  };
}

function mergeConfig(assemblerContext: AssemblerContext) {
  Object.assign(config, assemblerContext);
}

const config: Config = getConfig();

export { getConfig, mergeConfig };

export default config;
